const { dashboardMapping } = require("./dashboardMapping"),
    { flightMapping } = require("./flightMapping"),
    { hotelMapping } = require("./hotelMapping"),
    { railMapping } = require("./railMapping"),
    { signUpMapping } = require("./signUpMapping"),
    { guestMapping } = require("./guestMapping"),
    { loginMapping } = require("./LoginMapping"),
    { xtraaMapping } = require("./xtraaMapping");
    

const mapping = {
    Login: loginMapping,
    Dashboard: dashboardMapping,
    Flight: flightMapping,
    Hotel: hotelMapping,
    Rail: railMapping,
    SignUp: signUpMapping,
    Guest: guestMapping,
    Rewards: xtraaMapping
}

module.exports = { mapping }